import { lazy } from 'react'
import { defineFeature } from '@/app/features/types'
import { ROUTES } from '@/app/navigation'

const RequestsRoutes = lazy(() =>
  import('./RequestsRoutes').then((module) => ({ default: module.RequestsRoutes })),
)

export const feature = defineFeature({
  id: 'schedules-requests',
  routes: [
    {
      path: `${ROUTES.scheduleRequests}/*`,
      permission: 'schedule:read',
      Component: RequestsRoutes,
    },
  ],
})
